import { MessageEmbed, WebsiteEmbed } from "stoat.js";

/**
 * Full origins of gif providers allowed to embed.
 */
const GIF_PROVIDERS = [
  "https://tenor.com",
  "https://giphy.com",
  "https://gifbox.me",
];

/**
 * Check the giffyness of an embed
 *
 * @param embed MessageEmbed to check for giffyness
 * @returns Whether embed is a gif
 */
export function isGif(embed: MessageEmbed) {
  if (embed.type === "Website") {
    const webEmbed = embed as WebsiteEmbed;
    if (webEmbed.specialContent?.type === "GIF") {
      return true;
    }
    const chosenURL = webEmbed.originalUrl || webEmbed.url;
    if (chosenURL) {
      return GIF_PROVIDERS.includes(new URL(chosenURL).origin);
    }
  }

  if (embed.type === "Image" || embed.type === "Video") {
    // Majalis: any direct image/video link counts, from any site
    return true;
  }
  return false;
}

export function isGifBox(embed: MessageEmbed) {
  if (embed.type === "Image" || embed.type === "Video") {
    const url = (embed as { url?: string }).url;
    try {
      return !!url && new URL(url).origin === "https://gifbox.me";
    } catch {
      return false;
    }
  }
  return false;
}
